import { render, staticRenderFns } from "./SwiftNameForm.vue?vue&type=template&id=eef13004&scoped=true"
import script from "./SwiftNameForm.vue?vue&type=script&lang=js"
export * from "./SwiftNameForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef13004",
  null
  
)

export default component.exports